import { Component, Prop, Vue } from 'vue-property-decorator';
import appStore from '@/store/app';
import usersStore from '@/store/users';

@Component
export default class ResetPassword extends Vue {

   // Injectectd from url
   @Prop({ default: '' }) private readonly id!: string;
   @Prop({ default: '' }) private readonly token!: string;

   private password = '';
   private confirmPassword = '';

   get loading(): boolean {
      return appStore.isLoading;
   }

   private async reset() {

      if (this.password !== this.confirmPassword) {
         appStore.error({ message: 'La password e la password di conferma non coincidono' });
         return;
      }

      await usersStore.resetPasswordAsync(
         {
            id: this.id,
            token: this.token,
            password: this.password,
            confirmPassword: this.confirmPassword,
         })
         .then(() => { this.$emit('close'); })
         .catch((reason) => {
            appStore.error({ message: 'Password non resettata.' });
         });

   }
}
